import {createContext} from "react";

const StructuredLogContext = createContext();

export default StructuredLogContext;